import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { SortEnumType } from 'gql/graphql';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { catalogWorkTypesGql } from '../workOrderQueries';

const requestId = 'catalogWorkTypes';

const variables = {
    order: [
        {
            name: SortEnumType.Asc,
        },
    ],
    take: 50,
};

export const useCatalogWorkTypes = () => {
    const dispatch = useDispatch();

    const [makeResetCatalogWorkTypes] = useResetStoreData({ requestId });
    const [page, setPage] = useState(0);

    const [catalogWorkTypesResponse, catalogWorkTypesStatus, , catalogWorkTypesMakeRequest] = useRequest({
        requestId,
        query: catalogWorkTypesGql,
        variables,
        withEffect: false,
    });

    const catalogWorkTypesRequest = useCallback(
        (searchString?: string, currentPage = 1) => {
            if (catalogWorkTypesStatus === RequestStatus.FETCHING) {
                return;
            }

            setPage(currentPage + 1);

            dispatch(
                catalogWorkTypesMakeRequest({
                    order: variables.order,
                    take: searchString ? undefined : variables.take,
                    skip: searchString || currentPage === 1 ? 0 : currentPage * variables.take,
                    where: searchString ? { name: { containsi: searchString } } : undefined,
                } as any),
            );
        },
        [catalogWorkTypesMakeRequest, catalogWorkTypesStatus, dispatch],
    );

    const onNextPageRequest = useCallback(() => {
        catalogWorkTypesRequest('', page);
    }, [catalogWorkTypesRequest, page]);

    const hasNextPage = useMemo(
        () => !!catalogWorkTypesResponse?.catalogWorkTypes?.pageInfo?.hasNextPage,
        [catalogWorkTypesResponse?.catalogWorkTypes?.pageInfo?.hasNextPage],
    );

    const catalogWorkTypes = useMemo(
        () => catalogWorkTypesResponse?.catalogWorkTypes?.items || [],
        [catalogWorkTypesResponse?.catalogWorkTypes?.items],
    );

    useEffect(() => {
        makeResetCatalogWorkTypes(undefined);
    }, [makeResetCatalogWorkTypes]);

    return {
        catalogWorkTypes,
        catalogWorkTypesRequest,
        catalogWorkTypesResponse,
        catalogWorkTypesMakeRequest,
        makeResetCatalogWorkTypes,
        onNextPageRequest,
        catalogWorkTypesStatus,
        hasNextPage,
    };
};
